<template>
  <div class="slider-group">
    <div
      class="title-container slider-title"
      :style="{ 'text-align': options.align }"
    >
      <h3>{{ options.title }}</h3>
    </div>
    <div
      v-if="options.options.length > 1"
      class="slider-container"
      :style="{
        width: options.options.length * 35 - 38 + 'px',
        float: options.align
      }"
    >
      <span class="slider-label left">{{ options.options[0] }}</span>
      <span class="slider-label right">{{
        options.options[options.options.length - 1]
      }}</span>
      <range-slider
        class="slider"
        min="0"
        :max="options.options.length - 1"
        v-model="value"
        @change="$emit('set-val', options.title, options.options[value])"
      >
        <template #knob>
          <div class="inner-knob">
            {{ options.options[value] }}
          </div>
        </template>
      </range-slider>
    </div>
    <div
      class="single-option inner-knob"
      :style="{ float: options.align }"
      v-else
    >
      {{ options.options[0] }}
    </div>
  </div>
</template>

<script>
import { RangeSlider } from '@/plugins/vue-range-slider'

export default {
  data() {
    return {
      value: this.options.options.indexOf(this.activeSpecs[this.options.title])
    }
  },
  props: ['options', 'activeSpecs'],
  components: {
    RangeSlider
  }
}
</script>

<style lang="scss" scoped>
.slider-group {
  //  height: 60px;
  //margin-bottom: 13px;

  .slider-title {
    margin-bottom: 25px;
    height: auto;
  }
}

.card .title-container h3 {
  margin: -1px;
}

.slider-container {
  margin: 0 19px;
  position: relative;
  max-width: 165px;
}

.slider-label {
  top: -2px;
}

.single-option {
  width: 37px;
  height: 37px;
  background-color: var(--sub-color);
  color: white;
  border-radius: 35px;
  margin-top: -12px;
  line-height: 35px;
}
</style>
